import React from 'react'
import { useSelector } from 'react-redux'
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom'
import HomePage from '../pages/Home'
import ChooseTopicPage from '../pages/ChooseTopicPage'
import TopicPage from '../pages/TopicPage'
import BigMovesPage from '../pages/BigMovesPage'
import RuralPage from '../pages/RuralPage'
import DemographicsPage from '../pages/DemographicsPage'
import ThankYouPage from '../pages/ThankYouPage'

const privateRoutes = isActive => [
  { path: "/imagine/:surveyID/:step?", element: !isActive ? <Navigate to="/" replace={true} /> : <ChooseTopicPage /> },
  { path: "/topic/:surveyID/:pageID", element: !isActive ? <Navigate to="/" replace={true} /> : <TopicPage /> },
  { path: "/big-ideas/:surveyID/:pageID", element: !isActive ? <Navigate to="/" replace={true} /> : <BigMovesPage /> },
  { path: "/rural/:surveyID", element: !isActive ? <Navigate to="/" replace={true} /> : <RuralPage /> },
  { path: "/demographics", element: !isActive ? <Navigate to="/" replace={true} /> : <DemographicsPage /> },
  { path: "/thank-you", element: !isActive ? <Navigate to="/" replace={true} /> : <ThankYouPage /> },
]

const AppRouter = () => {
  const session = useSelector(({ qualtricsSurvey }) => qualtricsSurvey.session)

  const router = createBrowserRouter([
    { path: "/", element: <HomePage /> },
  ].concat(privateRoutes(!!session)), {
    basename: '/beheard',
  })

  return (
    <RouterProvider 
      router={router}
    />
  )
}

export default AppRouter
